<template>
  <div class="min-h-screen flex overflow-hidden bg-white">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
    <div class="md:hidden" v-show="showSidebar">
      <div class="fixed inset-0 flex z-40">
        <transition
          enter-active-class="transition-opacity ease-linear duration-8000"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition-opacity ease-linear duration-8000"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div class="fixed inset-0">
            <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
          </div>
        </transition>

        <transition
          enter-active-class="transition ease-in-out duration-8000 transform"
          enter-from-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-8000 transform"
          leave-from-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white">
            <div class="absolute top-0 right-0 -mr-12 pt-2">
              <button
                class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                @click="showSidebar = false"
              >
                <span class="sr-only">Close sidebar</span>
                <!-- Heroicon name: x -->
                <svg
                  class="h-6 w-6 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <nav class="px-2 space-y-1">
                <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
                <a
                  href="#plans"
                  @click="(showPlans = true), (showSidebar = false)"
                  class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                >
                  <!-- Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" -->
                  <!-- Heroicon name: home -->

                  <svg
                    class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>

                  Plans & Upgrade
                </a>

                <a
                  href="#account"
                  @click="showSidebar = false"
                  class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                >
                  <!-- Heroicon name: inbox -->
                  <svg
                    class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>

                  Account Settings
                </a>

                <a
                  href="#billing"
                  @click="showSidebar = false"
                  v-if="user.profile.proMembership.isActive"
                  class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                >
                  <!-- Heroicon name: chart-bar -->
                  <svg
                    class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                    ></path>
                  </svg>
                  Billing
                </a>
              </nav>
            </div>
          </div>
        </transition>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="flex-1 px-2 bg-white space-y-1">
              <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
              <a
                href="#plans"
                @click="showPlans = true"
                class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <!-- Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" -->
                <!-- Heroicon name: home -->

                <svg
                  class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  ></path>
                </svg>

                Plans & Upgrade
              </a>

              <a
                href="#account"
                class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <!-- Heroicon name: inbox -->
                <svg
                  class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>

                Account Settings
              </a>

              <a
                href="#billing"
                v-if="user.profile.proMembership.isActive"
                class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <!-- Heroicon name: chart-bar -->
                <svg
                  class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                  ></path>
                </svg>
                Billing
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
        <button
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
          @click="showSidebar = true"
        >
          <span class="sr-only">Open sidebar</span>
          <!-- Heroicon name: menu -->
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none">
        <div class="md:py-6">
          <div class="max-w-full">
            <div class="flex-col w-full">
              <Warning
                v-if="error"
                :isError="true"
                :content="error"
                class="mt-4"
              >
              </Warning>
              <Alert v-if="nameChangeSuccess" class="mt-4">
                Name updated successfully to "{{ user.data.displayName }}"!
              </Alert>
              <Plans
                id="plans"
                v-if="!user.profile.proMembership.isActive || showPlans"
                v-bind:user="user"
                :didSelectPlan="didSelectPlan"
                :loading="loading"
              ></Plans>
              <div class="" id="account">
                <div
                  class="bg-white py-6 px-4 sm:p-6 w-full border-t border-gray-300"
                >
                  <div>
                    <h2
                      id="payment_details_heading"
                      class="text-lg leading-6 font-medium text-gray-900"
                    >
                      Account Information
                    </h2>
                    <p class="mt-1 text-sm text-gray-500">
                      All relevant information for your account.
                    </p>
                  </div>
                  <Warning
                    class="mt-4"
                    v-if="
                      user.loggedIn &&
                      user.profile.proMembership.status == 'pastDue'
                    "
                  >
                    <p>
                      Something went wrong with your last payment, please
                      contact support to re-enable your subscription.
                    </p>
                    <button
                      @click="contactSupport"
                      type="button"
                      class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-4"
                    >
                      Contact Support
                    </button>
                  </Warning>

                  <div class="mt-6 grid grid-cols-4 gap-6">
                    <div class="col-span-4 sm:col-span-2">
                      <label
                        for="name"
                        class="block text-sm font-medium text-gray-700"
                        >Name</label
                      >
                      <div class="relative inline-block" @mouseenter="showNameEditButton = true" @mouseleave="showNameEditButton = false">
                        {{ user.data.displayName }}
                        <button
                          v-show="showNameEditButton"
                          @click="openNameChangeModal"
                          type="button"
                          class="ml-2 inline-flex items-center px-2 py-1 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          change name
                        </button>
                      </div>
                    </div>

                    <div class="col-span-4 sm:col-span-2">
                      <label
                        for="email"
                        class="block text-sm font-medium text-gray-700"
                        >Email</label
                      >
                      {{ user.data.email }}
                    </div>

                    <div class="col-span-4 sm:col-span-1">
                      <label
                        for="sub_status"
                        class="block text-sm font-medium text-gray-700"
                        >Subscription</label
                      >
                      {{ user.profile.proMembership.status }}
                    </div>
                  </div>
                </div>
                <div class="px-4 text-left sm:px-6">
                  <button
                    v-if="user.loggedIn"
                    @click="signOut"
                    type="button"
                    class="bg-gray-800 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    Sign out
                  </button>
                </div>
              </div>
              <div
                v-if="user.profile.proMembership.isActive"
                class="mt-6 w-full border-t border-gray-300"
                id="billing"
              >
                <div class="bg-white py-6 px-4 sm:p-6">
                  <div>
                    <h2
                      id="payment_details_heading"
                      class="text-lg leading-6 font-medium text-gray-900"
                    >
                      Billing Information
                    </h2>
                    <p class="mt-1 text-sm text-gray-500">
                      Everything related to billing.
                    </p>
                  </div>
                  <div class="mt-6 grid grid-cols-4 gap-6">
                    <template
                      v-if="user.profile.proMembership.stripeSubscription"
                    >
                      <div class="col-span-4 sm:col-span-2">
                        <label
                          for="name"
                          class="block text-sm font-medium text-gray-700"
                          >Fee</label
                        >
                        {{ chargePrice }} per {{chargePeriod}}
                      </div>

                      <div class="col-span-4 sm:col-span-2">
                        <label
                          for="name"
                          class="block text-sm font-medium text-gray-700"
                          >Next Billing Date</label
                        >
                        {{
                          user.profile.proMembership.stripeSubscription
                            .current_period_end | moment("dddd, MMMM Do YYYY")
                        }}
                      </div>
                    </template>

                    <div class="col-span-4 sm:col-span-2">
                      <label
                        for="sub_status"
                        class="block text-sm font-medium text-gray-700"
                        >Subscription Type</label
                      >
                      {{ user.profile.proMembership.status }}
                    </div>

                    <div class="col-span-4 sm:col-span-2">
                      <label
                        for="sub_status"
                        class="block text-sm font-medium text-gray-700"
                        >Invoice e-mail address</label
                      >
                      {{ user.data.email }}
                    </div>
                  </div>
                </div>
                <div class="px-4 text-left sm:px-6 space-x-5">
                  <button
                    v-if="
                      user.loggedIn &&
                      user.profile.proMembership.stripeSubscription != undefined && 
                      user.profile.proMembership.stripeSubscription.customer != undefined
                    "
                    @click="updateBilling"
                    type="button"
                    class="bg-gray-800 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    Manage Billing
                  </button>

                  <button
                    v-if="user.loggedIn"
                    @click="contactSupport"
                    type="button"
                    class="bg-gray-800 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    Contact Support
                  </button>

                  <button
                    v-if="user.loggedIn"
                    @click="cancelSubscription"
                    type="button"
                    class="bg-gray-800 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    Cancel Subscription
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <!-- Cancellation Confirmation Modal -->
    <div v-if="showCancelModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- Background overlay -->
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <!-- Modal panel -->
        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <!-- Warning icon -->
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.962-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Are you sure you want to cancel?
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  If there's an issue or you have any questions, you can also contact our support team for assistance before canceling your subscription.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3">
            <button
              @click="contactSupportFromModal"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm mb-3"
            >
              Contact Support
            </button>
            <button
              @click="proceedToCancel"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm mb-3"
            >
              Proceed to Cancel
            </button>
            <button
              @click="showCancelModal = false"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Support Contact Modal -->
    <div v-if="showSupportModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- Background overlay -->
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <!-- Modal panel -->
        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100">
              <!-- Email icon -->
              <svg class="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Contact Support
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Get help by emailing us at <span class="font-semibold">support@cloudemdr.com</span>
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3">
            <button
              @click="copyEmailAddress"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm mb-3"
            >
              Copy Email Address to Clipboard
            </button>
            <button
              @click="openEmailApp"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm mb-3"
            >
              Open in your Email App 
            </button>
            <button
              @click="showSupportModal = false"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Name Change Modal -->
    <div v-if="showNameChangeModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- Background overlay -->
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <!-- Modal panel -->
        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100">
              <!-- User icon -->
              <svg class="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Change Your Name
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Enter your new name below. This will update your display name across the application.
                </p>
              </div>
            </div>
          </div>

          <!-- Warning if there's an error -->
          <Warning v-if="nameChangeError" :isError="true" :content="nameChangeError" class="mt-4"></Warning>

          <!-- Name input form -->
          <div class="mt-4">
            <label for="new-name" class="block text-sm font-medium text-gray-700">New Name</label>
            <div class="mt-1">
              <input
                id="new-name"
                v-model="newName"
                type="text"
                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                :placeholder="user.data.displayName"
                maxlength="50"
                :disabled="nameChangeLoading"
              />
            </div>
          </div>

          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
            <button
              @click="confirmNameChange"
              type="button"
              :disabled="nameChangeLoading || !newName || newName.trim() === '' || newName.trim() === user.data.displayName"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg v-if="nameChangeLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ nameChangeLoading ? 'Updating...' : 'Update Name' }}
            </button>
            <button
              @click="cancelNameChange"
              type="button"
              :disabled="nameChangeLoading"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Plans from "./Plans.vue";
import { loadStripe } from "@stripe/stripe-js";
import Warning from "@/components/Warning.vue";
import Alert from "@/components/Alert.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      stripe: null,
      showPlans: false,
      showSidebar: false,
      showCancelModal: false,
      showSupportModal: false,
      showNameEditButton: false,
      showNameChangeModal: false,
      nameChangeSuccess: false,
      nameChangeError: null,
      nameChangeLoading: false,
      newName: '',
    };
  },
  components: {
    Plans,
    Warning,
    Alert,
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
    // because people have different plans, we display the price that we find in their stripe subscription value
    chargePrice: function () {
      if (this.user.profile.proMembership.stripeSubscription) {
        var monthlyPrice = new Intl.NumberFormat(this.$shared.locale, {
          style: "currency",
          currency: this.user.profile.proMembership.stripeSubscription.plan
            .currency,
        }).format(
          this.user.profile.proMembership.stripeSubscription.plan.amount / 100
        );
        return monthlyPrice;
      } else {
        return "Unknown - contact support if there's an issue";
      }
    },
    chargePeriod: function() {
      if (this.user.profile.proMembership.stripeSubscription) {
        return this.user.profile.proMembership.stripeSubscription.plan
      .interval; 
      } else {
        return "N/A";
      }
    }
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_API_KEY);
  },
  methods: {
    async signOut() {
      try {
        await this.$auth.logout();
        // Only redirect if we're not already on the home page
        if (this.$route.name !== 'home') {
          await this.$router.push({ name: "home" });
        }
      } catch (error) {
        console.error('Logout error:', error);
        Bugsnag.notify(error, {
        severity: 'warning',
        context: 'Logout Attempt',
        metaData: {
          errorType: error.name,
          errorMessage: error.message,
          route: this.$route.name
          }
        });

        this.error = error;
      }
    },
    didSelectPlan(plan) {
      this.plan = plan;
      this.loading = true;

      this.$store
        .dispatch("createCheckoutPage", {
          user: this.user,
          trialDuration: 21,
          planId: this.plan.planId,
        })
        .then((res) => {
          this.stripe
            .redirectToCheckout({
              sessionId: res.data.sessionId,
            })
            .then(() => {
              this.loading = false;
            })
            .catch((error) => {
              this.error = `${error}, please try again or contact support at ${this.$shared.email}`;
              this.loading = false;
            });
        })
        .catch((error) => {
          this.error = `${error}, please try again or contact support at ${this.$shared.email}`;
          this.loading = false;
        });
    },
    updateBilling() {
      this.$store
        .dispatch("createCustomerPortalPage", {
          customerId: this.user.profile.proMembership.stripeSubscription
            .customer,
        })
        .then((res) => {
          console.log(res);
          window.location.href = res.data.url;
        })
        .catch((error) => {
          this.error = `${error}, please try again or contact support at ${this.$shared.email}`;
        });
    },
    cancelSubscription() {
      sa_event("click_cancel_subscription");
      this.showCancelModal = true;
    },
    proceedToCancel() {
      this.showCancelModal = false;
      
      // Redirect to Stripe Customer Portal where users can cancel their subscription
      this.$store
        .dispatch("createCustomerPortalPage", {
          customerId: this.user.profile.proMembership.stripeSubscription
            .customer,
        })
        .then((res) => {
          window.location.href = res.data.url;
        })
        .catch((error) => {
          this.error = `${error}, please try again or contact support at ${this.$shared.email}`;
        });
    },
    contactSupportFromModal() {
      this.showCancelModal = false;
      this.showSupportModal = true;
      sa_event("click_contact_support_from_cancel_modal");
    },
    copyEmailAddress() {
      const email = 'support@cloudemdr.com';
      navigator.clipboard.writeText(email).then(() => {
        this.showSupportModal = false;
        // You could add a toast notification here if you have one
        alert('Email address copied to clipboard!');
      }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = email;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.showSupportModal = false;
        alert('Email address copied to clipboard!');
      });
      sa_event("copy_support_email");
    },
    openEmailApp() {
      this.showSupportModal = false;
      window.location.href = 'mailto:support@cloudemdr.com?subject=Cloud EMDR Support Request';
      sa_event("open_email_app_for_support");
    },
    contactSupport() {
      sa_event("click_contact_support");
      this.showSupportModal = true;
    },
    openNameChangeModal() {
      this.newName = this.user.data.displayName || '';
      this.nameChangeError = null;
      this.nameChangeSuccess = false;
      this.showNameChangeModal = true;
    },
    cancelNameChange() {
      this.showNameChangeModal = false;
      this.newName = '';
      this.nameChangeError = null;
      this.nameChangeLoading = false;
    },
    async confirmNameChange() {
      if (!this.newName || this.newName.trim() === '' || this.newName.trim() === this.user.data.displayName) {
        return;
      }

      this.nameChangeLoading = true;
      this.nameChangeError = null;

      try {
        await this.$auth.updateDisplayName(this.newName.trim());
        
        this.showNameChangeModal = false;
        this.nameChangeSuccess = true;
        this.newName = '';
        this.nameChangeLoading = false;

        setTimeout(() => {
          this.nameChangeSuccess = false;
        }, 5000);

      } catch (error) {
        console.error('Name update error:', error);
        this.nameChangeError = error.message || 'Failed to update name. Please try again.';
        this.nameChangeLoading = false;
      }
    },
  },
};
</script>
